import React from "react";
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';
import {BrowserRouter} from 'react-router-dom';
import { Provider as ReduxProvider } from "react-redux";
import axios from 'axios';

import App from "./App";
import configureStore from './redux/configureStore';

import "./App.css";
import "./index.css";
import "antd/dist/antd.css";
import "./common.css";

// CSRF: read XSRF-TOKEN cookie and attach as x-xsrf-token header on every POST/PUT/DELETE
function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[2]) : null;
}
axios.interceptors.request.use(config => {
    const method = (config.method || '').toUpperCase();
    if (!['GET', 'HEAD', 'OPTIONS'].includes(method)) {
        const token = getCookie('XSRF-TOKEN');
        if (token) {
            config.headers = config.headers || {};
            config.headers['x-xsrf-token'] = token;
        }
    }
    return config;
});

// Session timeout: redirect to /logout when server returns 401 SESSION_EXPIRED
axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            const errorCode = error.response.data && error.response.data.errorCode;
            if (errorCode === 'SESSION_EXPIRED') {
                console.warn('Session expired — redirecting to login');
                window.location.href = '/logout';
                return new Promise(() => {});
            }
        }
        return Promise.reject(error);
    }
);

const store = configureStore( window.__REDUX_STATE__ || {} );

const AppBundle = (
  <ReduxProvider store={store}>
      <BrowserRouter>
          <App />
      </BrowserRouter>
  </ReduxProvider>
);
const container = document.getElementById('root');
window.onload = () => {
Loadable.preloadReady().then(() => {
      ReactDOM.hydrate(          
          AppBundle,
          container
      );
  });
};
